angular.module('lf.common')

.directive('bazaarvoiceStars', function () {
  return function (scope, el, attrs) {
    scope.$on('bazaarvoice:fetched', function () {
      var bv = scope.bazaarvoiceProductData;
      var src = bv.reviews.totalCount
        ? 'http://leapfrog.ugc.bazaarvoice.com/bvstaging/8818mexp-en_us/' + bv.reviews.averageOverallRating + '/' + bv.reviews.overallRatingRange + '/rating.png'
        : 'http://leapfrog.ugc.bazaarvoice.com/bvstaging/static/8818mexp-en_US/translucent.gif';
      
      var $img = $('<img />');
      $img.addClass('bazaarvoice__stars-image');
      $img.attr('src', src);

      el.append($img);
    });
  }
});
